import { useTranslate } from '@c3po/i18n'
import CartProvider from '@cart/provider'
import CartWidget from '@cart/widget'
import { LeftMenuSectionSubTitle, LeftMenuSectionTitle } from '@front-web/header-revamped'
import { withTheme } from '@kawaui/theme'
import { useABtest } from '@narf/abtest'
import { useAuth } from '@narf/auth'
import { track } from '@narf/track'

import dynamic from 'next/dynamic'
import React from 'react'

import Footer from 'components/Footer/Footer'
import LoggedInFooter from 'components/Header/loggedInFooter'
import LoggedInHeader from 'components/Header/loggedInHeader'
import MessageCenterWidget from 'components/MessageCenterHeaderWidget'
import { cultureToCountryCode } from 'utils/methods'

import { Wrapper, LayoutWrapper, ComponentWrapper, HeaderWrapper } from './styles'

const DynamicHeader = dynamic(() => import('@front-web/header'))
const DynamicHeaderRevamped = dynamic(() => import('@front-web/header-revamped'))

type Props = {
  children?: React.ReactNode
  hasFooter?: boolean
  wrapperFacilIti?: string
}

const FlatLayout = React.memo(({ children = null, hasFooter = false, wrapperFacilIti }: Props) => {
  const { locale, siteId, memberId } = useAuth()
  const { i18n } = useTranslate()

  const countryCode = cultureToCountryCode(locale)
  const experiments = useABtest()

  const isLeftMenuRevamped = experiments?.postsales_tech_burger_menu_revamp_web?.variation?.name === 'var1_enabled'

  const LateralLoggedInHeader = isLeftMenuRevamped && !!memberId ? <LoggedInHeader /> : undefined

  const LateralLoggedInFooter = isLeftMenuRevamped && !!memberId ? <LoggedInFooter /> : undefined

  const revampedLoginText = (
    <div>
      <LeftMenuSectionTitle>{i18n('menu.title')}</LeftMenuSectionTitle>
      <LeftMenuSectionSubTitle>{i18n('opendoormenu.jointheveepeefamily')}</LeftMenuSectionSubTitle>
    </div>
  )
  const i18nCulture = {
    countryCode,
    locale,
    siteId,
  }

  const routing = { isExternal: true }

  const headerProps = {
    basketElement: <CartWidget track={track} />,
    lateralLoggedInHeader: LateralLoggedInHeader,
    lateralLoggedInFooter: LateralLoggedInFooter,
    hideActiveStyle: false,
    i18n: i18nCulture,
    isTransparent: false,
    memberId: memberId,
    messageCenterWidgetElement: <MessageCenterWidget memberId={memberId} siteId={siteId} />,
    routing,
    showMenu: true,
    showSearch: true,
    showSponsorship: true,
    showWhoWeAre: false,
  }
  return (
    <Wrapper>
      <LayoutWrapper id="Layout" data-facil-iti={wrapperFacilIti}>
        <HeaderWrapper>
          <CartProvider>
            {isLeftMenuRevamped ? (
              <DynamicHeaderRevamped {...headerProps} loginText={revampedLoginText} />
            ) : (
              <DynamicHeader
                i18n={i18nCulture}
                showSponsorship
                showWhoWeAre={false}
                routing={routing}
                basketElement={<CartWidget track={track} />}
                messageCenterWidgetElement={<MessageCenterWidget memberId={memberId} siteId={siteId} />}
              />
            )}
          </CartProvider>
        </HeaderWrapper>
        <ComponentWrapper>{children}</ComponentWrapper>
        {hasFooter && <Footer />}
      </LayoutWrapper>
    </Wrapper>
  )
})

FlatLayout.displayName = 'FlatLayout'

export default withTheme(FlatLayout)
